import React from "react";
import { Checkbox } from "@chakra-ui/core";
import { pxToRem } from "../../../utils/dimensionConverter";

export const CheckboxElement = ({ title, size, brand, props }) => {
  const styles = {
    borderColor: "#C3BFC3",
    borderRadius: pxToRem(6),
    outline: "none",
  };
  return (
    <div>
      <Checkbox size={size} variantColor={brand} {...styles} {...props}>
        {title}
      </Checkbox>
    </div>
  );
};

export default CheckboxElement;
